import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ProgressiveImage from '../ProgressiveImage/ProgressiveImage';
import './ArticleHero.less';

const getYoutubeId = (youtubeUrl) => {
    // NOTE: the following RegEx should be keept in sync with Hero Video validations in Contentful
    // https://app.contentful.com/spaces/gxwgulxyxxy1/content_types/article/fields
    const youtubeIdRegex =
        '^.*(?:youtu.be\\/|v\\/|e\\/|u\\/\\w+\\/|embed\\/|v=)([^#\\&\\?]*).*';
    const matches = youtubeUrl.match(youtubeIdRegex);
    return matches && matches[1];
};

export const Video = ({youtubeUrl}) => {
    const youtubeId = getYoutubeId(youtubeUrl);

    return (
        <div className="ArticleHero__video" style={{'--aspect-ratio': '16/9'}}>
            <iframe
                width="1600"
                height="900"
                src={`https://www.youtube.com/embed/${youtubeId}`}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                modestBranding="1"
                allowFullScreen
            />
        </div>
    );
};

const ArticleHero = ({title, image, video, renderedCrumbs}) => {
    return (
        <div className={cx('ArticleHero', {'ArticleHero--overlap': !video})}>
            <div className="ArticleHero__image">
                {video ? (
                    <Video youtubeUrl={video} />
                ) : (
                    image && (
                        <ProgressiveImage
                            src={image.url}
                            alt="article hero"
                            fit="fill"
                            critical
                        />
                    )
                )}
            </div>
            <div className="ArticleHero__content-container">
                <div className="ArticleHero__content article-content-container">
                    {renderedCrumbs}
                    <h1 className="ArticleHero__title" itemProp="headline">
                        {title}
                    </h1>
                </div>
            </div>
        </div>
    );
};

ArticleHero.propTypes = {
    title: PropTypes.string.isRequired,
    image: PropTypes.objectOf(PropTypes.string),
    video: PropTypes.string,
    renderedCrumbs: PropTypes.node,
};

export default ArticleHero;
